// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__fovYs","header":"ReportDetails_header__3KK5A","title":"ReportDetails_title__3ap4M","left":"ReportDetails_left__1sGoF"};